"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeStyles = exports.styles = exports.TooltipPopper = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function TooltipPopper(props) {
    var style = props.style, text = props.text;
    var _a = styles_1.useStyles(exports.styles), classes = _a.classes, css = _a.css;
    var sizeClasses = styles_1.useStyles(exports.sizeStyles).classes;
    var size = text && text.length > 60 ? 'big' : 'small';
    return react_1.default.createElement("div", { className: css(classes.base, sizeClasses[size], style) }, text);
}
exports.TooltipPopper = TooltipPopper;
exports.styles = function (theme) { return ({
    base: {
        borderRadius: theme.radius.popper,
        maxWidth: theme.breakpoints.size.lg,
        background: theme.pallete.gray.c20,
        color: theme.pallete.gray.c100,
        fontSize: '0.875rem',
        fontWeight: 'bold',
        lineHeight: 1.5,
    },
}); };
exports.sizeStyles = function () { return ({
    small: {
        textAlign: 'center',
        padding: '0.5rem',
    },
    big: {
        textAlign: 'left',
        padding: '1rem',
        maxWidth: 277,
    },
}); };
//# sourceMappingURL=TooltipPopper.js.map